const Verification = () => (
  <>
    <meta name="msvalidate.01" content="49A84271BDDA383603410B783428A45B" />
    <meta name="google-site-verification" content="gZoutuKyaBAseITF5HFxs7502vdgSyDlGFVcrM-3_68" />
    <meta name="facebook-domain-verification" content="jso33gutz25cozarhntdl864k8xtnf" />
  </>
);

export default Verification;
